// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"ac17ca0d","319":"a847730f","364":"68c46b9e","490":"db2ffc8b","864":"db2ffc8b"}[chunkId] + ".chunk.css";
};